import React, { ComponentProps } from 'react'

export const ChevronIcon = (
    props: ComponentProps<'svg'> & {
        direction: 'up' | 'down' | 'left' | 'right'
    }
) => {
    const angle = (() => {
        switch (props.direction) {
            case 'up':
                return 0
            case 'down':
                return 180
            case 'left':
                return -90
            case 'right':
                return 90
            default:
                return 0
        }
    })()

    return (
        <svg
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            color="#333333"
            {...props}
            style={{ transform: `rotate(${angle}deg)`, ...props.style }}
        >
            <path
                d="M1 5.73096L5 1.73096L9 5.73096"
                stroke="currentcolor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    )
}
